// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"style_iconStyle__hbi3f"};